import { IconTag } from "@/molecules/IconTag"
import { InsightsIcons, checkInsightValue } from "@/molecules/InsightsIcons"
import { ShowMore } from "@/molecules/ShowMore"

import styles from "./InsightsCell.module.scss"

import { InsightsCellComponent } from "."

export const InsightsCell: InsightsCellComponent = (props) => {
  const {
    id,
    items,
    values,
    t,
    tag,
    compact,
    tagIconSize = "xl",
    ...attr
  } = props
  const isArray = Array.isArray(values)

  if (tag) {
    let firstTrueValueIndex = -1
    if (compact) {
      firstTrueValueIndex = items.findIndex(
        (item, index) =>
          !!checkInsightValue(isArray ? values[index] : values[item.key])
      )
    }

    return items.map((item, index) => {
      const value = checkInsightValue(
        isArray ? values[index] : values[item.key]
      )

      if (!value) return null

      return (
        <IconTag
          key={index}
          icon={<item.Icon />}
          text={
            compact && index != firstTrueValueIndex
              ? "..."
              : t(`insights.${item.labelKey ?? item.key}`)
          }
          data-tag-key={item.key}
          data-tag-label={item.labelKey}
          iconSize={tagIconSize}
        />
      )
    })
  }

  const noTooltip = !Array.isArray(values) && values.allFalse

  if (noTooltip) {
    return <InsightsIcons noTooltip items={items} values={values} {...attr} />
  }

  return (
    <ShowMore
      id={id}
      label={
        <ShowMore.Label.Component>
          <InsightsIcons noTooltip items={items} values={values} {...attr} />
        </ShowMore.Label.Component>
      }
    >
      <ShowMore.Component
        title={t("general.insights")}
        classes={{ content: styles.contentPopover }}
      >
        {items.map((item, index) => {
          const value = checkInsightValue(
            isArray ? values[index] : values[item.key]
          )

          if (!value) return null

          return (
            <IconTag
              key={index}
              icon={<item.Icon />}
              text={t(`insights.${item.labelKey ?? item.key}`)}
              data-tag-key={item.key}
              data-tag-label={item.labelKey}
              iconSize={tagIconSize}
            />
          )
        })}
      </ShowMore.Component>
    </ShowMore>
  )
}
